/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Save_ButtonInputs */

const en_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Changes`)
};

const fr_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les modifications`)
};

const de_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen speichern`)
};

const it_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva modifiche`)
};

const ru_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить изменения`)
};

const es_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

const zh_cn2_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存更改`)
};

const ja_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を保存`)
};

const hi_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों को सुरक्षित करें`)
};

const pt_pt2_style_guide_manager_save_button = /** @type {(inputs: Style_Guide_Manager_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar alterações`)
};

/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Style_Guide_Manager_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_save_button = /** @type {((inputs?: Style_Guide_Manager_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_save_button(inputs)
	if (locale === "de") return de_style_guide_manager_save_button(inputs)
	if (locale === "it") return it_style_guide_manager_save_button(inputs)
	if (locale === "ru") return ru_style_guide_manager_save_button(inputs)
	if (locale === "es") return es_style_guide_manager_save_button(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_save_button(inputs)
	if (locale === "ja") return ja_style_guide_manager_save_button(inputs)
	if (locale === "hi") return hi_style_guide_manager_save_button(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_save_button(inputs)
	return en_style_guide_manager_save_button(inputs)
});